import './LandContractTermsPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import LandBottomLayout from '../common/LandBottomLayout'

import Shangbiao1 from '../../images/company/shangbiao1.png'
import Shangbiao2 from '../../images/company/shangbiao2.png'
import Shangbiao3 from '../../images/company/shangbiao3.png'

export default class LandContractTermsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <div className="LandContractTerms">
          <div className="LandContractTermsTitle">Keystride条款与条件</div>

          <div className="LandB">一、使用条款</div>
          <div className="LandD">
            这些条款和条件（“条款和条件”）适用于KeystrideValve.com以及所有其他获得凯士达授权的销售与服务中心（“凯士达”或“我们”或“我们的”）网站（统称为“站点”）。
          </div>

          <div className="LandB">二、用户访问</div>
          <div className="LandD">
            我方可在任何时间自行决定终止、变更、暂停或中止网站的任何方面内容及任何功能的可用性。我们也可能因任何原因在无需向您承担责任的情况下限制某些功能与服务的使用或限制您访问部分或所有网站的任何内容。
          </div>

          <div className="LandB">三、商标</div>
          <div className='LandD'>
            本公司合法拥有
          </div>
          <div className='LandShangbiaoWrapper'>
            <img src={Shangbiao1} className='LandShangbiao' />
            <img src={Shangbiao2} className='LandShangbiao' />
            <img src={Shangbiao3} className='LandShangbiao' />
          </div>
          <div className='LandD'>
            注册商标，为上述商标的唯一合法权利人。
          </div>
          <div className="LandD">
            凯士达保留有关其商标、商号、品牌名、商业外观的所有权利，其中包括名称“凯士达（Keystride）”、凯士达标识和/或在网站上引用的任何其它凯士达产品或品牌名。这些商标、商号、品牌名、商业外观和所有相关标识或图像都经注册，且/或是凯士达的普通法商标，并受中国与国际法律与条约的保护。本条款和条件不授予您使用上述商标、商号或商业外观的许可，您使用网站也不授予您上述许可。我方在此告知您凯士达将在法律允许的最大范围内积极落实知识产权，其中包括寻求民事救济与刑事诉讼。
          </div>

          <div className="LandB">四、限制性许可</div>
          <div className="LandD">
            网站上所有内容，包括但不限于文本、设计、图形、标识、图标、图像、音频片段、下载、界面、代码与软件、及前述内容的精选与安排（以下简称为“素材”），为凯士达或其内容供应商的专有财产，且为凯士达或其内容供应商所有，受著作权法、商标法和其他适用法律保护。针对凯士达所有的任何专利、条约、著作权、商标、商号、品牌名、商业外观或商业秘密，凯士达不授予您任何明示或暗示的权利。您可访问、复制、下载及打印网站上包含的素材仅供您个人及非商业用途适用，但您不得修改或删除在您访问、复制、下载或打印的素材上显示的任何版权、商标或其他专有通知。向您提供的素材是根据一个凯士达可自行酌情决定在任何时候可撤销的非独有限制许可来提供的。对素材的任何其他使用，其中包括但不限于对衍生作品进行修改、分发、传送、执行、广播、出版、上传、授予许可、翻译、进行逆向工程、转让或销售、或是创作皆明令禁止。
            您同意遵守所有可能不时更新的在网站上显示的所有新增限制。凯士达保留出于任何原因拒绝或取消任何人在网站上注册、从网站上移除任何人或禁止任何人使用网站的权利。凯士达、或其许可方或内容供应商对素材保留完整的所有权，其中包括所有相关的知识产权，并根据一个凯士达可自行酌情决定在任何时候可撤销的限制性许可向您提供素材。
            未经许可，您不得使用网站上的联系信息，其中包括进行市场推广等。您也不得运用任何拟用来损坏或阻扰网站正常运行的，或是以不正当方式从网站截获任何系统、数据或个人信息的硬件或软件。您同意不会以任何方式中断或试图扰乱网站的运行。凯士达保留根据其自行酌情决定，在任何时候不经通知限制或终止您访问或使用网站的权利。终止您对网站的访问或使用不会免除或影响凯士达在法律或衡平法上享有的任何其它权利或救济。
          </div>

          <div className="LandB">五、免责声明与有限保证</div>
          <div className="LandD">
            网站上的数据和信息应属准确，但也可能包含不精确的内容及排版错误。网站根据“现况”及“现有”基础提供。我方保留在任何时候限制或终止您访问网站或网站任何功能或部分的权利。凯士达就所有任何类型的明确或隐含保证做出明确的免责声明，其中包括但不限于适销性及针对特殊用途适用性的默示保证；以及网站上素材非侵权的任何保证；及在执行或交易过程中产生的默示保证；还包括但不限于访问网站不会间断、不会出差错或全面运作的保证；网站将是安全的保证；网站或让网站可用的服务器无病毒的保证；或是网站信息将是完整、准确或及时的保证。如您从网站下载任何素材，您是基于自身判断进行该操作且自担风险。如下载任何该等素材令您的计算机系统遭受到任何损害或是数据丢失，您将独自承担责任。您从凯士达或是通过或是从网站上获取的口头或书面建议或信息都不会产生任何类型的任何保证。针对在网站上运用素材，凯士达不会就其完整性、准确性、精确性、充分性、有用性、及时性、可靠性或其他方面做出任何保证或陈述。您确认如依赖该等建议、信息或素材，将自担风险。凯士达根据其自行酌情判断，保留改正网站任何部分或任何素材的错误或遗漏，并可能对网站、素材、产品、产品服务或网站任何地方说明的建议价格表在经过通知或不经通知的情况下随时进行任何其他变更的权利。
            某些司法辖区不允许排除默示担保，故以上排除条款可能不适用于您。
          </div>

          <div className="LandB">六、赔偿限制</div>
          <div className="LandD">
            您确认并同意针对自身使用网站承担全部责任。您也确认并同意在您使用网站期间发出或接收到的任何信息可能存在安全隐患，并可能被非授权方所截获。您还确认并同意您使用网站将自担风险，且网站向您免费开放。通过认可前述内容，您还确认并同意在适用法律允许的最大范围内，对由于网站、或由于您通过网站的一个连接访问的任何其他网站或由于我方因您发送给我方的通讯，或由于延误或未能使用网站，或由于在网站上广告的或是通过网站获取的任何信息、产品或服务，或是由于删除任何在网站上提交的或是张贴的任何素材而发起的任何行动或未能采取的任何行动，或是在其他情况下由于无论是根据合同、侵权、严格赔偿责任或其他的网站使用而引起的，或与前述内容相关而造成的任何直接的、间接地、惩罚性的、惩戒性的、附带的、特殊的、间接的或是其他损害（其中包括但不限于对您的信息操作系统造成的任何利润损失、业务中断、信息或程序丢失或其他损害），凯士达、其子公司或其授权的销售及服务中心概不负责，即便凯士达、其子公司或任何其授权销售及服务中心已被告知会有损害的可能。本免责声明不受限制地适用于由于任何操作或传输执行失败、错误、遗漏、中断、删除、缺陷、延误，计算机病毒、文件损坏、通讯线路故障、网络或系统停摆、您蒙受利润损失、或任何记录或数据的被盗、毁坏、未经授权访问、篡改、丢失或使用，及任何其他有形或无形的损失引起的任何损害或伤害。您特此确认并同意对于任何网站用户的任何诽谤、攻击或非法行为，凯士达、其子公司、或授权销售及服务中心概不负责。针对凯士达的任何上述主张或任何争议，您唯一且排他性的救济就是不再继续使用网站。
          </div>

          <div className="LandB">七、国际用户</div>
          <div className="LandD">
            网站由凯士达在其位于中国的办事处进行控制、运营及管理。凯士达不作任何网站素材可在美国之外其它地方可接受或可供使用的陈述。您确认并同意在任何内容都非法的地方使用或访问网站的任何内容都是禁止的。您不得使用违法中国出口法律与法规的网站或素材的任何内容。如您在中国以外的地方访问网站，您确认并同意您的访问是自担风险，并由自己负责遵守中国之外现有的所有及任何外国法律和法规。
          </div>

          <div className="LandB">八、赔偿</div>
          <div className="LandD">
            您同意由于您使用网站及对本协议的任何违反或涉嫌违反而引起的任何及所有损失、债务、开支、赔偿金及诉讼费，其中包括合理的律师费及法庭费用，会向凯士达、其高级管理人员、董事、员工、子公司、承包商、代理、许可人、服务供应商、分包商及供应商进行赔偿，为其辩护并使其免受伤害。
          </div>

          <div className="LandB">九、完整协议</div>
          <div className="LandD">
            本协议构成凯士达与您就您使用网站任何内容的完整协议。如有司法管辖权的法院发现协议的任何规定或协议的任何部分不可执行，则条款应在允许的最大范围内执行以便实现本协议之意图，并且本协议其余部分应持续完全有效。
          </div>

          <div className="LandB">十、适用法律和司法管辖区</div>
          <div className="LandD">
            您确认并同意本协议受中国法律管辖。您还明确同意由于本协议或您使用KeystrideValve.com引起或与之相关的任何索赔或诉讼都只能在排他性司法管辖区或是在中国境内法院提起。为提起该等索赔或诉讼，您进一步同意接受上述法院的对人管辖权。
          </div>

          <div className="LandB">十一、使用条款的变更</div>
          <div className="LandD">
            凯士达保留其自行判断在任何时候全部或部分变更、修改、添加或移除本条款和条件的任何部分。本协议中的变更在该等变更发通知发布于KeystrideValve.com上时即生效。您须负责定期检查我方对使用条款做出的任何变更。
          </div>

          <div className="LandB">十二、联系方式</div>
          <div className="LandD">
            您若对本条款和条件有任何问题或评论，请通过KeystrideValve.com网站上所提供的联系方式联系我们。
          </div>
        </div>

        <LandBottomLayout {...this.props} />
      </div>
    )
  }

  viewPrivacyPolicy = () => {
    this.props.history.push('/privacy_policy')
  }
}
